export class ImportarUnidadTransporteDTO {

    //Atributos
    codigo: string;
    nombre: string;
    descripcion: string; // Added from API
    empresaTransporte: string; // Added from API
    ruc: string;
    direccion: string;
    telefono: string;
    correo: string;
    contacto: string;
    esExclusivo: string;
    estado: string;
    hub: string;
    evidenciaAdicional: string;
    uniTraPlaca: string;
    uniTraSensor: string;
    uniTraSensorMin: string;
    uniTraSensorMax: string;
    uniTraCapacidad: string;
    uniTraCargaUtil: string;
    uniTraMonitoreoGps: string;
    traDocumento: string;
    traNombre: string;
    traApellido: string;
    traLicencia: string;

    //Validaciones
    valid: boolean;
    empresaTransporteValida: boolean;
    codigoValido: boolean;
    nombreValido: boolean;
    rucValido: boolean;
    direccionValido: boolean;
    telefonoValido: boolean;
    correoValido: boolean;
    contactoValido: boolean;
    exclusivoValido: boolean;
    estadoValido: boolean;
    hubValido: boolean;
    evidenciaAdicionalValido: boolean;
    monitoreoGpsValido: boolean;
    placaValido: boolean;
    capacidadValido: boolean;
    cargaUtilValido: boolean;
    traDocumentoValido: boolean;
    traNombreValido: boolean;
    traApellidoValido: boolean;
    traLicenciaValido: boolean;
    sensorValido: boolean;
    sensorMinValido: boolean;
    sensorMaxValido: boolean;

    //Mensajes de error
    mensajeErrorEmpTransporteNoExistente: string;
    mensajeErrorCodigo: string;
    mensajeErrorNombre: string;
    mensajeErrorDescripcion: string; // Added from API
    mensajeErrorRuc: string;
    mensajeErrorDireccion: string;
    mensajeErrorTelefono: string;
    mensajeErrorCorreo: string;
    mensajeErrorContacto: string;
    mensajeErrorEsExclusivo: string;
    mensajeErrorEstado: string;
    mensajeErrorHub: string;
    mensajeErrorEvidenciaAdicional: string;
    mensajeErrorMonitoreoGps: string;
    mensajeErrorPlaca: string;
    mensajeErrorCapacidad: string;
    mensajeErrorCargaUtil: string;
    mensajeErrorTraDocumento: string;
    mensajeErrorTraNombre: string;
    mensajeErrorTraApellido: string;
    mensajeErrorTraLicencia: string;
    mensajeErrorSensor: string;
    mensajeErrorSensorMin: string;
    mensajeErrorSensorMax: string;

    //Constructor
    constructor() { };

    //Metodo Color de Celda
    cellStyle(isValid: boolean) {
        if (!isValid)
            return "red-bg";
        return "";
    }

    copiar(objeto: any) {
        //Propios
        this.codigo = objeto.codigo;
        this.nombre = objeto.nombre;
        this.descripcion = objeto.descripcion;
        this.empresaTransporte = objeto.empresaTransporte;
        this.ruc = objeto.ruc;
        this.direccion = objeto.direccion;
        this.telefono = objeto.telefono;
        this.correo = objeto.correo;
        this.contacto = objeto.contacto;
        this.esExclusivo = objeto.esExclusivo;
        this.estado = objeto.estado;
        this.hub = objeto.hub;
        this.evidenciaAdicional = objeto.evidenciaAdicional;
        this.uniTraPlaca = objeto.uniTraPlaca;
        this.uniTraMonitoreoGps = objeto.uniTraMonitoreoGps;
        this.uniTraSensor = objeto.uniTraSensor;
        this.uniTraSensorMin = objeto.uniTraSensorMin;
        this.uniTraSensorMax = objeto.uniTraSensorMax;
        this.uniTraCapacidad = objeto.uniTraCapacidad;
        this.uniTraCargaUtil = objeto.uniTraCargaUtil;
        this.traDocumento = objeto.traDocumento;
        this.traNombre = objeto.traNombre;
        this.traApellido = objeto.traApellido;
        this.traLicencia = objeto.traLicencia;

        this.valid = objeto.valid;
        this.empresaTransporteValida = objeto.empresaTransporteValida;
        this.codigoValido = objeto.codigoValido;
        this.nombreValido = objeto.nombreValido;
        this.rucValido = objeto.rucValido;
        this.direccionValido = objeto.direccionValido;
        this.telefonoValido = objeto.telefonoValido;
        this.correoValido = objeto.correoValido;
        this.contactoValido = objeto.contactoValido;
        this.exclusivoValido = objeto.exclusivoValido;
        this.estadoValido = objeto.estadoValido;
        this.hubValido = objeto.hubValido;
        this.evidenciaAdicionalValido = objeto.evidenciaAdicionalValido;
        this.placaValido = objeto.placaValido;
        this.monitoreoGpsValido = objeto.monitoreoGpsValido;
        this.capacidadValido = objeto.capacidadValido;
        this.cargaUtilValido = objeto.cargaUtilValido;
        this.traDocumentoValido = objeto.traDocumentoValido;
        this.traNombreValido = objeto.traNombreValido;
        this.traApellidoValido = objeto.traApellidoValido;
        this.traLicenciaValido = objeto.traLicenciaValido;
        this.sensorValido = objeto.sensorValido;
        this.sensorMinValido = objeto.sensorMinValido;
        this.sensorMaxValido = objeto.sensorMaxValido;

        this.mensajeErrorEmpTransporteNoExistente = objeto.mensajeErrorEmpTransporteNoExistente;
        this.mensajeErrorCodigo = objeto.mensajeErrorCodigo;
        this.mensajeErrorNombre = objeto.mensajeErrorNombre;
        this.mensajeErrorDescripcion = objeto.mensajeErrorDescripcion || objeto.mensajeErrorNombre; // Map to handle API variations
        this.mensajeErrorRuc = objeto.mensajeErrorRuc;
        this.mensajeErrorDireccion = objeto.mensajeErrorDireccion;
        this.mensajeErrorTelefono = objeto.mensajeErrorTelefono;
        this.mensajeErrorCorreo = objeto.mensajeErrorCorreo;
        this.mensajeErrorContacto = objeto.mensajeErrorContacto;
        this.mensajeErrorEsExclusivo = objeto.mensajeErrorEsExclusivo;
        this.mensajeErrorEstado = objeto.mensajeErrorEstado;
        this.mensajeErrorHub = objeto.mensajeErrorHub;
        this.mensajeErrorEvidenciaAdicional = objeto.mensajeErrorEvidenciaAdicional;
        this.mensajeErrorPlaca = objeto.mensajeErrorPlaca;
        this.mensajeErrorMonitoreoGps = objeto.mensajeErrorMonitoreoGps;
        this.mensajeErrorCapacidad = objeto.mensajeErrorCapacidad;
        this.mensajeErrorCargaUtil = objeto.mensajeErrorCargaUtil;
        this.mensajeErrorTraDocumento = objeto.mensajeErrorTraDocumento;
        this.mensajeErrorTraNombre = objeto.mensajeErrorTraNombre;
        this.mensajeErrorTraApellido = objeto.mensajeErrorTraApellido;
        this.mensajeErrorTraLicencia = objeto.mensajeErrorTraLicencia;
        this.mensajeErrorSensor = objeto.mensajeErrorSensor;
        this.mensajeErrorSensorMin = objeto.mensajeErrorSensorMin;
        this.mensajeErrorSensorMax = objeto.mensajeErrorSensorMax;
    }
}